// import 'bootstrap/scss/bootstrap.scss'
import '../scss/styles.scss'

function MainApp({ Component, pageProps }) {
  return <Component {...pageProps} />
}

export default MainApp
